import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  scope?: string;
}

interface State {
  hasError: boolean;
  message: string;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : 'Erro inesperado.',
    };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(`[A3GS] Erro isolado em ${this.props.scope ?? 'componente'}:`, error, info);
  }

  private recover = (): void => {
    this.setState({ hasError: false, message: '' });
  };

  render(): ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <section className="component-error" role="alert" aria-live="assertive">
        <div className="component-error__content">
          <span className="section-tag">ERRO ISOLADO</span>
          <h2>Esta parte do sistema encontrou um problema</h2>
          <p>
            O restante da aplicação continua disponível. Tente carregar esta parte novamente.
          </p>
          <details>
            <summary>Detalhes técnicos</summary>
            <pre>{this.state.message}</pre>
          </details>
          <button type="button" className="btn btn-primary" onClick={this.recover}>
            Tentar novamente
          </button>
        </div>
      </section>
    );
  }
}
